import { createWebHistory, createRouter } from 'vue-router'
import { isSuperAdmin, isSystemAdmin } from '@/utils/sysRole'
import {
  isLoggedIn,
  promptLogin,
  loginPageRoute
} from '@/utils/loginFlow'
import { syncAppSessionFromStorage } from '@/utils/appAuth'
import HomeView from './HomeView.vue'
import AboutView from './AboutView.vue'
import LoginView from './LoginView.vue'
import RegisterView from './RegisterView.vue'
import WeChatCallbackView from './WeChatCallbackView.vue'
import OfficialCallbackView from './OfficialCallbackView.vue'
import MomentView from './MomentView.vue'
import BlogView from './BlogView.vue'
import NewBlogView from './NewBlogView.vue'
import BlogDetailView from './BlogDetailView.vue'
import BlogListView from './BlogListView.vue'
import FeedbackView from './FeedbackView.vue'
import FAQView from './FAQView.vue'
import HelpView from './HelpView.vue'
import TeamView from './TeamView.vue'
import ContactView from './ContactView.vue'
import UserInfoView from './UserInfoView.vue'
import UserAccount from './UserAccount.vue'
import MentalTestView from './MentalTestView.vue'
import ExamesView from './ExamesView.vue'
import PeopleView from './PeopleView.vue'
import LikeView from './LikeView.vue'
import MyPage from './MyPage.vue'
import CreateMomentView from './CreateMomentView.vue'
import BlogEditView from './BlogEditView.vue'
import ExamDetailView from './ExamDetailView.vue'
import ExamEditView from './ExamEditView.vue'
import ExamCreateView from './ExamCreateView.vue'
import TestView from './TestView.vue'
import TestResultListView from './TestResultListView.vue'
import TestResultDetailView from './TestResultDetailView.vue'
import ProfilePage from './ProfilePage.vue'
import VisiteView from './VisiteView.vue'
import SearchView from './SearchView.vue'
import BlacklistView from './BlacklistView.vue'
import RechargeView from './RechargePage.vue'
import RechargeListView from './RechargeListView.vue'
import TransactionListView from './TransactionListView.vue'
import KnowledgeCoursesView from './KnowledgeCoursesView.vue'
import KnowledgeCourseDisplay from './components/KnowledgeCourseDisplay.vue'
import KnowledgeCourseAdmin from './components/KnowledgeCourseAdmin.vue'
// import KnowledgePointAdmin from './components/KnowledgePointAdmin.vue'
import KnowledgePointsView from './KnowledgePointsView.vue'
import KnowledgeResourceAdminView from './KnowledgeResourceAdminView.vue'
import KnowledgeGraphEditor from './KnowledgeGraphEditor.vue'
import KnowledgeGraphEditorJointJS from './KnowledgeGraphEditorJointJS.vue'
import KnowledgeDemo from './demo/knowledge-demo.vue'
import UserLearningProgressView from './UserLearningProgressView.vue'
import AdminDashboard from './views/AdminDashboard.vue'
import AdminLayout from './views/AdminLayout.vue'
import UserManagement from './views/UserManagement.vue'
import RolePermissionManagement from './views/RolePermissionManagement.vue'
import UserProfileAuditView from './views/UserProfileAuditView.vue'
import IdCardAuditView from './views/IdCardAuditView.vue'
import BlogManagement from './views/BlogManagement.vue'
import ImageManagement from './views/ImageManagement.vue'
import DatabaseBackupView from './views/DatabaseBackupView.vue'
import HomeCarouselManagement from './views/HomeCarouselManagement.vue'
import HomeNewsManagement from './views/HomeNewsManagement.vue'
import InviteCodeManagement from './views/InviteCodeManagement.vue'
import InviteTreeManagement from './views/InviteTreeManagement.vue'
import UserIpLogManagement from './views/UserIpLogManagement.vue'
import AdminExamResultManagement from './views/AdminExamResultManagement.vue'
import SecurityCaptchaView from './SecurityCaptchaView.vue'
import InviteCodesView from './InviteCodesView.vue'
import ReferralCouponsView from './ReferralCouponsView.vue'
import ReferralEarningsView from './ReferralEarningsView.vue'
import ReferralCouponManagement from './views/ReferralCouponManagement.vue'
import ReferralBindingsManagement from './views/ReferralBindingsManagement.vue'
import DesignHubView from './views/DesignHubView.vue'
import HomeNewsDetailView from './HomeNewsDetailView.vue'
import ExamManagement from './views/ExamManagement.vue'
import AdminExamDetailView from './views/AdminExamDetailView.vue'
import ExamYamlExportView from './views/ExamYamlExportView.vue'
import RealNameVerificationView from './RealNameVerificationView.vue'
import AIChatView from './AIChatView.vue'
import DownloadAppView from './DownloadAppView.vue'
import H5ExamResultView from './H5ExamResultView.vue'
import { saveHomeScrollPosition, scrollPageToTop } from '@/utils/homeScroll'

const routes = [
  { path: '/', component: HomeView },
  { path: '/home/news/:id', name: 'HomeNewsDetail', component: HomeNewsDetailView },
  { path: '/about', component: AboutView },
  { path: '/login', component: LoginView },
  { path: '/security/captcha', name: 'SecurityCaptcha', component: SecurityCaptchaView },
  { path: '/register', component: RegisterView },
  { path: '/wechatcallback', component: WeChatCallbackView },
  { path: '/officialcallback', component: OfficialCallbackView },
  { path: '/moment', component: MomentView },
  { path: '/blogs', component: BlogView },
  { path: '/blogs/create', component: NewBlogView },
  { path: '/blogs/:id', component: BlogDetailView },
  { path: '/blogs/list/my', component: BlogListView, meta: { requiresAuth: true } },
  { path: '/blog', redirect: '/blogs' },
  { path: '/blog/create', redirect: '/blogs/create' },
  { path: '/blog/list/my', redirect: '/blogs/list/my' },
  { path: '/blog/edit/:id', redirect: to => `/blogs/edit/${to.params.id}` },
  { path: '/blog/:id', redirect: to => `/blogs/${to.params.id}` },
  { path: '/feedback', component: FeedbackView },
  { path: '/faq', component: FAQView },
  { path: '/help', component: HelpView },
  { path: '/design', name: 'DesignHub', component: DesignHubView },
  { path: '/design/:docId', name: 'DesignHubDoc', component: DesignHubView },
  { path: '/team', component: TeamView },
  { path: '/contact', component: ContactView },
  { path: '/user/info', component: UserInfoView },
  { path: '/user/password', name: 'UserPassword', component: UserAccount, meta: { requiresAuth: true } },
  { path: '/user/account', redirect: '/user/password' },
  { path: '/mentaltest', component: MentalTestView },
  { path: '/exames', name: 'Exames', component: ExamesView },
  { path: '/testlist', redirect: '/exames' },
  { path: '/people', component: PeopleView, meta: { requiresAuth: 'prompt' } },
  { path: '/like', component: LikeView, meta: { requiresAuth: 'prompt' } },
  { path: '/my', component: MyPage, meta: { requiresAuth: 'prompt' } },
  { path: '/invite/codes', name: 'InviteCodes', component: InviteCodesView, meta: { requiresAuth: true } },
  { path: '/referral/coupons', name: 'ReferralCoupons', component: ReferralCouponsView, meta: { requiresAuth: true } },
  { path: '/referral/earnings', name: 'ReferralEarnings', component: ReferralEarningsView, meta: { requiresAuth: true } },
  { path: '/moment/create', name: 'CreateMoment', component: CreateMomentView },
  { path: '/blogs/edit/:id', name: 'BlogEdit', component: BlogEditView },
  { path: '/exam/create', redirect: '/admin/exam/create' },
  { path: '/exam/:id', name: 'ExamDetail', component: ExamDetailView },
  { path: '/exam/edit/:id', redirect: to => `/admin/exam/edit/${to.params.id}` },
  { path: '/exam/take/:id', name: 'Test', component: TestView },
  { path: '/profile/:id',  name: 'ProfilePage', component: ProfilePage },
  { path: '/exam/result/list/:id', name: 'TestResultList', component: TestResultListView, meta: { requiresAuth: true }  },
  { path: '/exam/result/:id', name: 'TestResultDetail',  component: TestResultDetailView,  meta: { requiresAuth: true }  },
  { path: '/visite', name: 'visite', component: VisiteView, meta: { requiresAuth: 'prompt' } },
  { path: '/blacklist', name: 'blacklist', component: BlacklistView, meta: { requiresAuth: 'prompt' } },
  { path: '/search', name: 'search', component: SearchView, meta: { requiresAuth: 'prompt' } },
  { path: '/ai-chat', name: 'AIChat', component: AIChatView },
  { path: '/download-app', name: 'DownloadApp', component: DownloadAppView },
  // H5 兼容旧链接，统一到主测评页
  { path: '/h5/exam/take/:id', redirect: to => `/exam/take/${to.params.id}` },
  { path: '/h5/exam/result', name: 'H5ExamResult', component: H5ExamResultView },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAuth: true, requiresAdmin: true },
    children: [
      { path: '', name: 'admin', component: AdminDashboard },
      { path: 'users', name: 'user-management', component: UserManagement },
      { path: 'roles', name: 'role-permission-management', component: RolePermissionManagement },
      { path: 'invite-codes', name: 'invite-code-management', component: InviteCodeManagement },
      { path: 'invite-tree', name: 'invite-tree-management', component: InviteTreeManagement },
      { path: 'referral-coupons', name: 'referral-coupon-management', component: ReferralCouponManagement },
      { path: 'referral-bindings', name: 'referral-bindings-management', component: ReferralBindingsManagement },
      { path: 'user-ip-logs', name: 'user-ip-log-management', component: UserIpLogManagement },
      { path: 'user-audit', name: 'user-profile-audit', component: UserProfileAuditView },
      { path: 'idcard-audit', name: 'idcard-audit', component: IdCardAuditView },
      { path: 'blogs', name: 'blog-management', component: BlogManagement },
      { path: 'home-carousel', name: 'home-carousel-management', component: HomeCarouselManagement },
      { path: 'home-news', name: 'home-news-management', component: HomeNewsManagement },
      { path: 'images', name: 'image-management', component: ImageManagement },
      { path: 'exames', name: 'exam-management', component: ExamManagement },
      { path: 'exam-results', name: 'admin-exam-results', component: AdminExamResultManagement },
      {
        path: 'exam-results/:id',
        name: 'admin-exam-result-detail',
        component: TestResultDetailView,
        meta: { adminResult: true }
      },
      { path: 'exam/create', name: 'admin-exam-create', component: ExamCreateView },
      { path: 'exam/edit/:id', name: 'admin-exam-edit', component: ExamEditView },
      { path: 'exam/:id', name: 'admin-exam-detail', component: AdminExamDetailView },
      { path: 'exam/:id/yaml', name: 'admin-exam-yaml', component: ExamYamlExportView },
      { path: 'knowledge/courses', name: 'knowledge-course-admin', component: KnowledgeCourseAdmin },
      { path: 'knowledge/points', name: 'knowledge-point-admin', component: KnowledgePointsView },
      { path: 'knowledge/resources', name: 'knowledge-resource-admin', component: KnowledgeResourceAdminView },
      {
        path: 'database-backup',
        name: 'database-backup',
        component: DatabaseBackupView,
        meta: { requiresSuperAdmin: true }
      }
    ]
  },
  { path: '/real-name-verification',   name: 'real-name-verification',  component: RealNameVerificationView,  meta: {    requiresAuth: true  }  },
  { path: '/recharge',  name: 'recharge',  component: RechargeView,  meta: {    requiresAuth: true  } },
  { path: '/recharge/list',  name: 'recharge-list',  component: RechargeListView,  meta: {    requiresAuth: true   }  },
  { path: '/transactions',  name: 'transactions',  component: TransactionListView,  meta: {     requiresAuth: true  } },
  { path: '/knowledge/courses',  component: KnowledgeCoursesView,  meta: {     requiresAuth: false  } },
  {
    path: '/knowledge/courses/display/:courseId',
    component: KnowledgeCourseDisplay,
    meta: { requiresAuth: false }
  },
  { path: '/knowledge/courses/admin', redirect: '/admin/knowledge/courses' },
  { path: '/knowledge/points/admin', redirect: '/admin/knowledge/points' },
  { path: '/knowledge/demo', component: KnowledgeDemo },
  { path: '/knowledge/progress',  name: 'UserLearningProgress', component: UserLearningProgressView,  meta: {    requiresAuth: true  }  },
  { path: '/knowledge/graph/editor',  name: 'KnowledgeGraphEditor',  component: KnowledgeGraphEditor,  meta: {    requiresAuth: true   } },
  { path: '/knowledge/graph/editor/jointjs',  name: 'KnowledgeGraphEditorJointJS',  component: KnowledgeGraphEditorJointJS,  meta: {    requiresAuth: true   } },
  { path: '/knowledge/resource/admin', redirect: '/admin/knowledge/resources' }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.name === 'HomeNewsDetail') {
      return { top: 0, left: 0 }
    }
    return false
  }
})

const FRIENDS_LOGIN_MSG = '朋友功能需要登录后才能使用，是否前往登录？'
const MY_LOGIN_MSG = '需要登录后才能查看「我的」，是否前往登录？'
const COURSE_LOGIN_MSG = '需要登录后才能查看课程详情，是否前往登录？'
const DEFAULT_LOGIN_MSG = '此页面需要登录后才能访问，是否前往登录？'

function loginPromptMessage(to) {
  if (to.path === '/my') {
    return MY_LOGIN_MSG
  }
  if (to.path.startsWith('/knowledge/courses/display')) {
    return COURSE_LOGIN_MSG
  }
  if (['/search', '/people', '/like', '/visite', '/blacklist'].includes(to.path)) {
    return FRIENDS_LOGIN_MSG
  }
  return DEFAULT_LOGIN_MSG
}

// Navigation guard
router.beforeEach(async (to, from, next) => {
  if (from.path === '/' && to.name === 'HomeNewsDetail') {
    saveHomeScrollPosition()
  }

  const token = localStorage.getItem('jwt_token')
  const userInfo = localStorage.getItem('user_info')
  const loggedIn = isLoggedIn()

  const authMode = to.meta.requiresAuth
  if (authMode && !loggedIn) {
    const returnPath = to.fullPath
    const message = loginPromptMessage(to)

    if (authMode === 'prompt') {
      const result = await promptLogin(message)
      if (result === 'navigate') {
        next(loginPageRoute(returnPath))
      } else {
        next(false)
      }
      return
    }

    if (authMode === true) {
      next(loginPageRoute(returnPath))
      return
    }
  } else if (to.meta.requiresSuperAdmin && token && userInfo) {
    const user = JSON.parse(userInfo)
    if (isSuperAdmin(user.sysRole)) {
      next()
    } else {
      next('/admin')
    }
  } else if (to.meta.requiresAdmin && token && userInfo) {
    const user = JSON.parse(userInfo)
    if (isSystemAdmin(user.sysRole)) {
      next()
    } else {
      next(loginPageRoute(to.fullPath))
    }
  } else {
    next()
  }
})

router.afterEach((to) => {
  if (localStorage.getItem('jwt_token')) {
    syncAppSessionFromStorage()
  }
  if (to.name === 'HomeNewsDetail') {
    scrollPageToTop()
  }
})

export default router